<template>
  <main class="page">
    <PageTitle
      v-if="$route.meta.haveTitle"
      :left="$route.meta.titleLeft"
      :breadcrumb.sync="$route.meta.haveBreadcrumb"
      :currentPage.sync="currentPage"
    />

    <div class="page-content">
      <keep-alive>
        <router-view
          v-if="$route.meta.keepAlive && $route.meta.layout !== 'error'"
          :currentPage.sync="currentPage"
        />
      </keep-alive>

      <router-view
        v-if="!$route.meta.keepAlive && $route.meta.layout !== 'error'"
        :currentPage.sync="currentPage"
      />

      <router-view v-if="$route.meta.layout === 'error'" />
    </div>
  </main>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue';

export default {
  components: {
    PageTitle,
  },
  data() {
    return {
      currentPage: [],
    };
  },
};
</script>
